import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["anchorClass"];
import { createVNode as _createVNode } from "vue";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { defineComponent, h } from 'vue';
import Abstract from '../abstract';
import { Anchor } from 'ant-design-vue';
var AnchorLink = Anchor.Link;
var _toAnchorNest = function _toAnchorNest(anchors) {
  var map = new Map();
  // fix: filter undefined element, i don't know how it come
  var _anchors = anchors.filter(function (item) {
    return item !== undefined && item !== null;
  });
  _anchors.forEach(function (item) {
    return map.set(item.id, item);
  });
  _anchors.forEach(function (anchor) {
    var els = anchor.el.querySelectorAll('*[anchor-id]');
    els.forEach(function (el) {
      var _anchor = map.get(el.id);
      map.delete(el.id);
      anchor.behind.push(_anchor);
    });
    if (anchor.behind.length > 0) {
      anchor.children = _toAnchorNest(anchor.behind);
    }
  });
  return _toConsumableArray(map.values());
};
var parseAnchor = function parseAnchor(_anchors) {
  var anchors = _anchors.map(function (_ref) {
    var id = _ref.id,
      title = _ref.title,
      order = _ref.order,
      children = _ref.children;
    var anchor = {
      id: id,
      title: title,
      order: order,
      children: children && parseAnchor(children)
    };
    return anchor;
  });
  return anchors;
};
var sortAnchor = function sortAnchor(anchors) {
  var max = 0;
  anchors.forEach(function (item) {
    if (item.children && item.children.length > 0) {
      sortAnchor(item.children);
    }
    if (item.order !== undefined) {
      max = Math.max(item.order, max);
    }
  });
  anchors.forEach(function (item) {
    item.order = item.order === undefined ? ++max : item.order;
  });
  anchors.sort(function (a, b) {
    return a.order - b.order;
  });
};
export default defineComponent({
  name: 'AnchorBox',
  extends: Abstract,
  emits: ['click', 'change'],
  props: {
    affix: {
      type: Boolean,
      default: true
    },
    bounds: {
      type: Number,
      default: 5
    },
    anchorClass: String,
    getContainer: Function,
    offsetBottom: Number,
    offsetTop: Number,
    showInkInFixed: Boolean,
    wrapperClass: String,
    wrapperStyle: Object,
    getCurrentAnchor: Function,
    targetOffset: Number
  },
  data: function data() {
    return {
      className: 'anchor-box',
      anchorList: []
    };
  },
  created: function created() {
    window.addEventListener('anchor:update', this.anchorListener);
  },
  beforeUnmount: function beforeUnmount() {
    window.removeEventListener('anchor:update', this.anchorListener);
  },
  methods: {
    anchorListener: function anchorListener() {
      var elements = this.$el.querySelectorAll('*[anchor-id]');
      var _anchors = [];
      elements.forEach(function (el) {
        var order = el.getAttribute('anchor-order');
        var title = el.getAttribute('anchor-title');
        var anchor = {
          id: el.id,
          title: title === null ? undefined : title,
          order: order && isNaN(Number(order)) ? undefined : parseInt(order),
          behind: [],
          el: el
        };
        _anchors.push(anchor);
      });
      var anchors = _toAnchorNest(_anchors);
      var anchorList = parseAnchor(anchors);
      sortAnchor(anchorList);
      this.anchorList = anchorList;
    },
    renderAnchorLinks: function renderAnchorLinks(anchors) {
      var _this = this;
      var items = anchors.map(function (anchor) {
        var id = anchor.id,
          title = anchor.title,
          children = anchor.children;
        return h(AnchorLink, {
          href: '#' + id,
          title: title
        }, function () {
          return children ? _this.renderAnchorLinks(children) : [];
        });
      });
      return items;
    }
  },
  render: function render() {
    var _dft = this.$slots.default && this.$slots.default();
    var prefixCls = this.prefixCls,
      $props = this.$props,
      renderAnchorLinks = this.renderAnchorLinks,
      anchorList = this.anchorList;
    var anchorClass = $props.anchorClass,
      props = _objectWithoutProperties($props, _excluded);
    return _createVNode("div", {
      "class": prefixCls
    }, [h(Anchor, _objectSpread({
      class: anchorClass
    }, props), function () {
      return renderAnchorLinks(anchorList);
    }), _dft]);
  }
});